import styled from 'styled-components';

export const SubtitleWrapper = styled.div`
  text-align: ${({ align }) => align || 'center'};
  font-size: ${({ fontSize }) => fontSize || '1.5rem'};
  margin: ${({ margin }) => margin || '0.5rem 1rem'};
  background-color: ${({ background }) => background || 'transparent'};
  color: ${({ color }) => color || '#333'};
  padding: ${({ padding }) => padding || '0.75rem 0'};

  @media (max-width: 768px) {
    font-size: ${({ fontSizeMobile }) => fontSizeMobile || '1.2rem'};
    margin: ${({ margin }) => margin || '0.5rem 1rem'};
    padding: ${({ paddingMobile }) => paddingMobile || '0.5rem 0'};
  }
`;